import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;
    return {
        userMenuItem: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            padding: theme.spacing(1),
            '& .MuiButton-startIcon': {
                marginLeft: 0,
            },
        },
        iconContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0.75),
            borderRadius: '50%',
            fontSize: 20,
            backgroundColor: isDarkMode ? 'rgb(255,255,255,0.1)' : 'rgb(228, 230, 235)',
        },
        userMenuItemText: {
            marginLeft: theme.spacing(0.5),
            color: theme.palette.text.primary,
            fontWeight: 500,
        },
        bc: {
            '& path': {
                fill: isDarkMode ? 'rgb(238,238,238)' : 'rgb(35,35,35)',
            },
        },
    };
});
